import Vue from 'vue'
import VueCropper from "vue-cropper"

Vue.use(VueCropper)